<template>
  <v-app>
    <Nav />
    <v-main>
      <v-progress-linear :active="loading" indeterminate fixed />
      <Intro />
      <v-container>
        <Main />
      </v-container>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
import Nav from '@/components/Nav.vue'
import Intro from '@/components/Intro.vue'
import Main from '@/components/Main.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',
  components: {
    Nav,
    Intro,
    Main,
    Footer,
  },
  computed: {
    ...mapState([
      'loading'
    ]),
  }
}
</script>

<style scopes lang="scss">
  h2 {
    color: $brand-primary;
    font-family: $heading-font-family;
    text-transform: uppercase;
    text-align: center;
    font-size: 1.5rem;
    margin: 0 0 15px;

    @media screen and (min-width: 600px) {
      font-size: 2.5rem;
      margin: 30px 0;
    }
  }
</style>
